import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from "react";

export type GlobalContext = {
  firstPageLoading: boolean;
  firstPageLoaded: () => void;
};

export const GlobalContext = createContext<GlobalContext>({
  firstPageLoading: true,
  firstPageLoaded: () => {},
});

export const GlobalContextProvider = ({ children }: PropsWithChildren) => {
  const [firstPageLoading, setFirstPageLoading] = useState(true);
  const firstPageLoaded = useCallback(() => {
    setFirstPageLoading(false);
  }, []);

  const state = useMemo(
    () => ({
      firstPageLoaded: firstPageLoaded,
      firstPageLoading: firstPageLoading,
    }),
    [firstPageLoaded, firstPageLoading],
  );

  return <GlobalContext.Provider value={state}>{children}</GlobalContext.Provider>;
};

export const useGlobalContext = () => useContext(GlobalContext);
